"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeUnit = void 0;
// 以毫秒计算的单位常量
// 1000 ms = (1 * TimeUnit.Second)
var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["Second"] = 1000] = "Second";
    TimeUnit[TimeUnit["Minute"] = 60000] = "Minute";
    TimeUnit[TimeUnit["Hour"] = 3600000] = "Hour";
    TimeUnit[TimeUnit["Day"] = 86400000] = "Day";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
